"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildInputFieldOptionsDownshift = exports.canShowAddButton = exports.filterItems = exports.getSelectedSuggestionsIndex = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var getSelectedSuggestionsIndex = function getSelectedSuggestionsIndex(suggestions, selectedItem) {
  if (suggestions && selectedItem[0]) {
    return suggestions.findIndex(function (item) {
      return item.value === selectedItem[0].value;
    });
  }

  return -1;
};

exports.getSelectedSuggestionsIndex = getSelectedSuggestionsIndex;

var filterItems = function filterItems(inputValue, ignoreFields, item, selectedItems) {
  var typedValue = inputValue && inputValue.toLowerCase();

  if (typedValue && typedValue.length >= 1) {
    for (var property in item) {
      // eslint-disable-line no-unused-vars
      var propertyValue = item[property];

      if ((0, _isNil["default"])(propertyValue)) {
        continue;
      }

      var suggestion = typeof propertyValue === 'string' ? propertyValue : propertyValue.toString();
      var isIgnoredProperty = ignoreFields && ignoreFields.includes(property);
      var doesntContainIgnoredProp = !isIgnoredProperty || !ignoreFields || ignoreFields.length === 0;
      var isntAlreadySelected = !selectedItems || selectedItems.length === 0 || selectedItems && selectedItems.length && selectedItems.indexOf(item) === -1;
      var lowercaseSuggestion = suggestion && suggestion.toLowerCase && suggestion.toLowerCase();

      if (lowercaseSuggestion && lowercaseSuggestion.includes(typedValue) && doesntContainIgnoredProp && isntAlreadySelected) {
        return item;
      }
    }

    return null;
  }

  if (selectedItems && selectedItems.length > 0) {
    if (selectedItems.indexOf(item) > -1) {
      return null;
    }

    return item;
  }

  return item;
};

exports.filterItems = filterItems;

var canShowAddButton = function canShowAddButton(inputValue, filteredSuggestions, selectedSuggestions) {
  var suggestionMatches = filteredSuggestions.filter(function (suggestion) {
    for (var property in suggestion) {
      // eslint-disable-line no-unused-vars
      var value = suggestion[property];

      if (value === inputValue) {
        return suggestion;
      }
    }
  });
  var preSelectedMatches = selectedSuggestions.filter(function (item) {
    return item.value === inputValue;
  });
  return suggestionMatches.length === 0 && preSelectedMatches.length === 0;
};

exports.canShowAddButton = canShowAddButton;

var buildInputFieldOptionsDownshift = function buildInputFieldOptionsDownshift(_ref) {
  var getLabelProps = _ref.getLabelProps,
      getInputProps = _ref.getInputProps,
      InputAdornment = _ref.InputAdornment,
      getInputPropsObj = _ref.getInputPropsObj,
      handleInputBlur = _ref.handleInputBlur,
      handleInputChange = _ref.handleInputChange,
      mode = _ref.mode,
      validationError = _ref.validationError,
      dataElementSuffix = _ref.dataElementSuffix,
      label = _ref.label,
      required = _ref.required;

  var _getInputProps = getInputProps(getInputPropsObj),
      _onBlur = _getInputProps.onBlur,
      _onChange = _getInputProps.onChange,
      onFocus = _getInputProps.onFocus,
      inputProps = (0, _objectWithoutProperties2["default"])(_getInputProps, ["onBlur", "onChange", "onFocus"]);

  var inputLabelPropOptions = (0, _objectSpread2["default"])({}, getLabelProps(), {
    shrink: true
  });
  var inputPropOptions = {
    startAdornment: mode === 'inline' ? InputAdornment : null,
    onBlur: function onBlur(e) {
      handleInputBlur(e); // Passed down handler

      _onBlur(e); // Generated by Downshift

    },
    onChange: function onChange(event) {
      handleInputChange(event);

      _onChange(event);
    },
    onFocus: onFocus
  };
  var labelElem = label ? _react["default"].createElement(_react["default"].Fragment, null, label, required && "\xA0*") : label;
  var inputOptions = {
    fullWidth: true,
    label: labelElem,
    InputLabelProps: inputLabelPropOptions,
    InputProps: inputPropOptions,
    inputProps: inputProps,
    error: validationError,
    dataElementSuffix: dataElementSuffix
  };
  return inputOptions;
};

exports.buildInputFieldOptionsDownshift = buildInputFieldOptionsDownshift;